export const CommonComponents={
    "选择时间":"选择时间",
    "不限制":"不限制",
    "不限":"不限",
    "添加文件类型":"添加文件类型",
    "请输入文件类型":"请输入文件类型",
    "请选择文件类型":"请选择文件类型",
    "确定要删除文件类型":"确定要删除文件类型",
    "删除后将不可恢复":"删除后将不可恢复",
    "设置满分条件":"设置满分条件",
    "满分条件":"满分条件",
    "回复":"回复",
    "条满分":"条满分",
    "选择小组批次":"选择小组批次",
    "请选择小组批次":"请选择小组批次",
    "立即发布":"立即发布",
    "请选择要发送的学生":"请选择要发送的学生",
    "暂时不支持视频播放":"暂时不支持视频播放",
    "暂时不支持音频播放":"暂时不支持音频播放",
    "下载":"下载",
    "发送":"发送",
    "个附件":"个附件",
    "上传":"上传",
    "外部浏览器打开":"外部浏览器打开",
    "点击下载":"点击下载",
    "由于微信浏览器本身的限制":"说明：由于微信浏览器本身的限制，不允许直接下载，请按照上面图示，选择浏览器，在浏览器里下载",
    "答题卡":"答题卡",
    "已完成":"已完成",
    "数值":"数值",
    "正确答案":"正确答案",
    "我的答案":"我的答案",
    "试题解析":"试题解析",
    "点击过快":"点击过快，正在保存答案中...",
    "请输入答案":"请输入答案",
    "参考答案":"参考答案",
    "保存答题":"保存答题",
    "对":"对",
    "错":"错",
    "如有描述":"如有描述，请输入",
    "本题得分":"本题得分",
    "分值":"分值",
    "分":"分",
    "项":"项",
    "匿名":"匿名",
    "实名":"实名",
    "难度":"难度",
    "第一题":"第一题",
    "最后一题":"最后一题",
    "下一题":"下一题",
    "上一题":"上一题",
    difficulty:{
        "易":"易",
        "中":"中",
        "难":"难",
    },
    SubjectType:{
        "判断题":"判断题",
        "单选题":"单选题",
        "多选题":"多选题",
        "简答题":"简答题",
        "投票单选":"投票单选",
        "投票多选":"投票多选",
        "数值评价题":"数值评价题",
        "匿名开放题":"匿名开放题",
        "拍照题":"拍照题",
        "段落说明题":"段落说明题",
        "不定项选择题":"不定项选择题",
        "填空题":"填空题",
        "文件题":"文件题",  
    },
    Comment:{
        "实名发表":"实名发表",
        "发表内容":"发表内容",
    },
    "确认提交":"确认提交？",
    "提交之后将无法进行更改":"提交之后将无法进行更改",
    "全部题型":"全部题型",
    "按题号排序":"按题号排序",
    "按得分率排序":"按得分率排序",
    "人参与":"人参与",
    "人":"人",
    "得分率":"得分率",
    "查看学生作答":"查看学生作答",
    "确认要删除此错题吗":"确认要删除此错题吗",
    "删除后无法恢复":"删除后无法恢复!",
    "题号":"题号",
    "查看试题答案及解析":"查看试题答案及解析",
    "暂无":"暂无",
    "人答题":"人答题",
    "展示词云":"展示词云",
    "学习中":"学习中",
    "未学习":"未学习",
    "学习状态":"学习状态",
    "已学习":"已学习",
    "请选择":"请选择",
    "会议号":"会议号：",
    "会议密码":"会议密码：",
    "会议时间":"会议时间：",
    "搜索学生姓名学号":"搜索学生姓名、学号",
    "发布时间":"发布时间",
    Vipdg:{
        "是否开通会员":"是否开通会员？",
        "非会员附件不能超过150M开通课堂派VIP可上传2G附件另外尊享更多VIP会员功能":"非会员附件不能超过150M，开通课堂派VIP可上传2G附件，另外尊享更多VIP会员功能",
        "开通VIP":"开通VIP",
        "非VIP最多可创建10个课程包含删除和归档的课程您的课程已达到上限开通VIP可继续创建课程并且无上线另外VIP可尊享更多权益":'非VIP最多可创建10个课程（包含删除和归档的课程），您的课程已达到上限，开通VIP可继续创建课程并且无上线，另外VIP可尊享更多权益',
        "您当时是学生VIP无法转换成老师身份如有特殊需要请联系客服进行修改":"您当时是学生VIP，无法转换成老师身份，如有特殊需要，请联系客服进行修改",
        "vip限时特惠":"vip限时特惠",
        "当前弹幕特效体验次数已用完开通vip畅享超酷弹幕特效和更多权益":"当前弹幕特效体验次数已用完，开通vip，畅享超酷弹幕特效和更多权益！",
        "开通vip可继续使用弹幕效果是否开通vip":"开通vip可继续使用弹幕效果，是否开通vip？",
    },
    "读取中":"读取中...",
    "上传中":"上传中...",
    "上传完成":"上传完成",
    "此视频暂无法播放请稍后再试":"此视频暂无法播放，请稍后再试",
    "该资源无法提供下载":"该资源无法提供下载！",
    "已经是第一页":"已经是第一页",
    "已经是最后一页":"已经是最后一页",
    "确定要删除吗":"确定要删除吗",
    "提醒":"提醒",
    "标题":"标题",
    "从备课区导入":"从备课区导入",
    "从课程导入":"从课程导入",
    "从慕课资源导入":"从慕课资源导入",
    "请输入内容":"请输入内容",
    "人次学习":"人次学习",
    "全部学校":"全部学校",
    "全部专业":"全部专业",
    "正在导入":"正在导入...",
    "数字评价题":"数字评价题",
    "颜色选择":"颜色选择",
    "默认":"默认",
    "动画选择":"动画选择",
    "弹幕动画预览":"弹幕动画预览",
    "无":"无",
    "立即参与":"立即参与",
    "人发表意见":"人发表意见",
    "查看":"查看",
    "个名额共":"个名额，（共",
    "个）":"个）",
    "暂无记录":"暂无记录",
    "暂无内容发表第一条弹幕吧":"暂无内容，发表第一条弹幕吧",
    "加入互动":"加入互动",
    "暂无互动试题":"暂无互动试题",
    "老师已关闭弹幕":"老师已关闭弹幕",
    "发言历史":"发言历史",
    "老师暂未开启直播课件同屏":"老师暂未开启直播",
    "如未自动播放请点击播放":"如未自动播放，请点击播放",
    "同屏中":"同屏中",
    "连接失败":"连接失败",
    "刷新一下":"刷新一下",
    "发言":"发言",
    "弹幕记录":"弹幕记录",
    "课堂记录":"课堂记录",
    "展开画面":"展开画面",
    "请答题":"请答题",
    "历史发言":"历史发言",
    "老师已开启抢答":"老师已开启抢答",
    "是否抢答":"是否抢答",
    "正在直播上课":"正在直播/上课",
    "课堂已结束正在检查是否有互动和抢答":"课堂已结束！正在检查，是否有互动和抢答",
    "抢答已结束":"抢答已结束",
    "老师已禁止弹幕":"老师已禁止弹幕",
    "发送成功":"发送成功",
    "本次课堂已结束":"本次课堂已结束",
    "老师已开启弹幕":"老师已开启弹幕",
    "老师已关闭同屏":"老师已关闭同屏",
    "老师已开启同屏":"老师已开启同屏",
    "老师已关闭直播":"老师已关闭直播",
    "老师发起了互动答题":"老师发起了互动答题",
    "是否参与答题":"是否参与答题",
    "加入":"加入",
    "已将疑问标记给老师":"已将疑问标记给老师",
    "已取消疑问":"已取消疑问",
    "活动类型名称10字以内":"活动类型名称（10字以内）",
    "新建活动内容":"新建活动内容",
    "请输入活动名称":"请输入活动名称",
    "课程达成度指标":"课程达成度指标",
}